import React from 'react'

import Card from 'components/Card'
import ClickoutWrapper from 'components/ClickoutWrapper'
import CtaButton from 'components/CtaButton'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Logo from 'components/Logo'
import Rating from 'components/Rating'
import { EventContext, useEventContext } from 'context/EventContext'
import PricingDisplay from 'screens/serp/components/SerpContentRich/components/PricingDisplay/PricingDisplay'

import classes from './ProductCard.module.scss'

const ProductCard = ({ listing, listingPosition }) => {
  const { addEvent } = useEventContext({ engagementComponent: 'featured-products' })
  return (
    <Card className={classes.root}>
      <div>
        <div className={classes.heading}>
          <ClickoutWrapper
            isClickout
            url={listing.cta_urls.cta}
            buyerIntentProductId={listing.global_product_id}
            buyerIntentSourceLocation="featured-products:logo"
            buyerIntentTrackAdClick
            className={classes.logoContainer}
            listingPosition={listingPosition}
            {...addEvent({
              productClickPosition: listingPosition,
              engagementDetails: 'logo_product',
              engagementDestination: 'go-to_vendor-website',
              name: 'engagement_product_clickout',
            })}
          >
            <Logo className={classes.logo} src={`${listing.logo_url}`} alt={`${listing.name} logo`} size={44} />
          </ClickoutWrapper>
          <div className={classes.info}>
            <ClickoutWrapper
              url={listing.cta_urls.cta}
              isClickout
              buyerIntentProductId={listing.global_product_id}
              buyerIntentSourceLocation="featured-products:name"
              buyerIntentTrackAdClick
              listingPosition={listingPosition}
              {...addEvent({
                productClickPosition: listingPosition,
                engagementDetails: 'text-link_product-name',
                engagementDestination: 'go-to_vendor-website',
                name: 'engagement_product_clickout',
              })}
            >
              <Link className={classes.title}>
                {listing.name}
                {listing.is_premium && (
                  <Icon className={classes.clickoutIcon} icon={['far', 'external-link']} size="12" />
                )}
              </Link>
            </ClickoutWrapper>
            <EventContext value={{ engagementComponent: 'featured-products' }}>
              <Rating.Link
                isCompact
                average={listing.rating_avg}
                totals={listing.num_reviews}
                href={listing.cta_urls.reviews}
              />
            </EventContext>
          </div>
        </div>

        <PricingDisplay pricing={listing.pricing} />

        <ClickoutWrapper
          listingPosition={listingPosition}
          url={listing.cta_urls.cta}
          isClickout
          buyerIntentProductId={listing.global_product_id}
          buyerIntentSourceLocation="featured-products:main-cta"
          buyerIntentTrackAdClick
          className={classes.ctaWrapper}
          {...addEvent({
            productClickPosition: listingPosition,
            engagementDestination: 'go-to_vendor-website',
            engagementDetails: 'button_visit-website',
            name: 'engagement_product_clickout',
          })}
        >
          <CtaButton fullWidth variant="contained">
            visit website <Icon icon={['far', 'external-link']} size="12" />
          </CtaButton>
        </ClickoutWrapper>
      </div>
    </Card>
  )
}
export default ProductCard
